// extracted by mini-css-extract-plugin
export default {"form":"AddOfferView_form__2Ufnk","error":"AddOfferView_error__Zu0-O"};